import { setAuthenticated } from '../state/session'

export function getToken(): string | null {
  const envToken = import.meta.env.VITE_DEV_BEARER as string | undefined
  const stored = localStorage.getItem('access')
  return stored || envToken || null
}

export function setToken(token: string) {
  localStorage.setItem('access', token)
  setAuthenticated(true)
}

export function clearToken() {
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
  setAuthenticated(false)
}

export function authHeaders(init?: HeadersInit): HeadersInit {
  const t = getToken()
  return t ? { ...(init || {}), Authorization: `Bearer ${t}` } : (init || {})
}

export function getRefreshToken(): string | null {
  return localStorage.getItem('refresh')
}

export function setRefreshToken(token: string) {
  localStorage.setItem('refresh', token)
}
